<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存-单规格
    -->
  <div>
    <el-form-item label="产品价格：" width="80" :rules="[{ required: true, message: '请填写产品价格' }]" 
    prop="model.sku.product_price">
    <span v-if="type == 'edit'">
        <el-input type="number" :disabled="form.supplySetting&&form.supplySetting.is_supply&&form.supplySetting.product_price_edit!=1" 
      v-model="form.model.sku.product_price" class="max-w460"></el-input>
      </span>
      <span v-if="type == 'add'">
        <el-input type="number"  v-model="form.model.sku.product_price" class="max-w460"></el-input>
      </span>
    
    </el-form-item>
    <el-form-item :label="form.supply_price_name+'：'" width="80"
      >
    
      <span v-if="type == 'edit'">
        <el-input type="number"  :disabled="form.supplySetting&&form.supplySetting.is_supply&&form.supplySetting.product_price_edit!=1" 
        v-model="form.model.sku.product_supply_price" class="max-w460"></el-input>
      
      </span>
      <span v-if="type == 'add'">
        <el-input type="number"  v-model="form.model.sku.product_supply_price" class="max-w460"></el-input>
      </span>
      <!-- <div v-if="!form.no_supply">（给平台的供货价格，结算按照此价格进行结算）</div> -->
    </el-form-item>

    <el-form-item  label="商品利润：" width="80"  v-if=" form.model.sku.product_price && form.model.sku.product_supply_price">
      <div>{{ form.model.sku.product_price - form.model.sku.product_supply_price }}元</div>
    </el-form-item>

    <el-form-item  v-if="form.no_supply" label="最低渠道价：" width="80" >
      <el-input type="number" v-model="form.model.sku.agent_min_price" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item  label="最低渠道利润：" width="80"  v-if="form.model.sku.agent_min_price  && form.model.sku.product_supply_price">
      <div>{{ form.model.sku.agent_min_price - form.model.sku.product_supply_price }}元</div>
    </el-form-item>
    <el-form-item  v-if="form.no_supply" label="最高渠道价：" width="80"  >
      <el-input type="number" v-model="form.model.sku.agent_max_price" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item  label="最高渠道利润：" width="80"  v-if="form.model.sku.agent_max_price &&  form.model.sku.product_supply_price">
      <div>{{ form.model.sku.agent_max_price - form.model.sku.product_supply_price }}元</div>
    </el-form-item>
    <el-form-item label="产品划线价：" :rules="[{ required: true, message: '请填写产品划线价' }]" >
      <el-input type="number" v-model="form.model.sku.line_price" class="max-w460"></el-input>
     </el-form-item>
    <el-form-item label="库存数量：" :rules="[{ required: true, message: '请填写库存数量' }]" prop="model.sku.stock_num">
      <el-input type="number" v-model="form.model.sku.stock_num" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="商品重量(Kg)：" prop="model.sku.product_weight">
      <el-input type="number" v-model="form.model.sku.product_weight" class="max-w460"></el-input>
    </el-form-item>
  </div> 
</template>

<script>
  export default{
    props:['type'],
    inject: ["form"],
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/spec/Single.vue